<template>
  <section>
    <div
      v-if="!isEdit"
      class="item">
      <div class="header">
        <span class="header_title">Product Settings</span>
        <v-button
          green
          @click="handleAdd(1)">Edit</v-button>
      </div>
      <p
        v-if="formData.setting==0"
        class="color-dark fs-14 fw-400 mg-t-20 mg-b-20">{{getOptionName('product_setting_type',formData.setting)}}</p>
      <template v-else>
        <product-setting-display
          :form="formData"
          :table-data="tableData"></product-setting-display>
      </template>
    </div>
    <product-setting-table
      v-if="isEdit"
      :form="formData"
      @update="handleUpdate"
      @cancel="isEdit = false"></product-setting-table>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {
  getAccountProductSettingList,saveAccountProductSettingList} from '@api/account'
import ProductSettingTable from '@/views/accounts/components/product-setting-table'
import ProductSettingDisplay from './product-setting-display'

export default {
  name: 'product-setting',
  components:{
    ProductSettingDisplay,
    ProductSettingTable,
  },
  mixins: [MixinOptions],
  data(){
    return {
      showSettingDialog:false,
      isEdit:false,
      formData:{
        setting:'',
        way:'',
        products:[]
      },
      tableData:[]
    }
  },
  computed:{
    customerId(){
      return this.$route.query.customer_id
    }
  },
  mounted() {
    this.handleUpdate()
  },
  methods:{
    handleRefresh(){

    },
    handleAdd(type){
      this.isEdit = true
    },
    async handleUpdate(){
      await this.network().getAccountProductSettingList()
      this.isEdit = false
    },
    network(){
      return {
        getAccountProductSettingList: async () => {
          let params = {
            customer_id: this.customerId
          }
          const {data} = await getAccountProductSettingList(params)
          let {list=[],setting='',way=''} = data||{}
          this.tableData = list
          this.formData.setting = setting
          this.formData.way = way
          this.formData.products = list
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.item{
  margin-top: 24px;
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .setting-box{
    span{
      border: 1px solid rgba(106, 115, 125, 1);
      padding:1px 8px;
      border-radius: 20px;
      margin-right: 16px;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .table_group{
    margin-top: 20px;
    .table_item{
      .tr{
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        min-height: 40px;
        display: flex;
        padding: 10px 15px;
        .td{
          flex: 1;
          display: flex;
          //align-items: center;
          font-weight: 400;
          font-size: 14px;
          min-height: 20px;
          color: #24292E;
          &.name{
            //min-width: 280px;
            max-width: 400px;
            word-break: break-word;
            .pct{
              font-weight: 600;
              font-size: 14px;
            }
          }
          &.center{
            flex: 2;
            min-width: 200px;
            justify-content: center;
          }
          &.operation{
            //min-width: 200px;
            justify-content: flex-end;
            color: #0366D6;
            .del{
              color: #CB2431;
            }
            span+span{
              margin-left: 15px;
            }
          }
          .file_name{
            font-weight: 600;
            color: #0366D6;
          }
          .icon{
            //border-radius: 100px;
            //height: 20px;
            //padding: 1px 8px;
            //margin-left: 15px;
            //font-weight: 600;
            //text-align: center;
            //min-width: 70px;
            &.green{
              border: 1px solid #28A745;
              color: #22863A;
            }
            &.gray{
              border: 1px solid #6A737D;
              color: #24292E;
            }
          }
        }
        &.bold{
          background: #F6F8FA;
          .td{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
        &.empty{
          justify-content: center;
          color: #909399;
          font-size: 14px;
        }
        &.blue_bg{
          background: #F1F8FF;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &+.tr{
          border-top: 0;
        }
      }
    }
    .text-decoration{
      text-decoration:line-through;
    }
    .mg-lr-4{
      margin-left: 4px;
      margin-right: 4px;
    }
    .tips{
      color: #6A737D;
    }
  }
  .icon{
    margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    display: block;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
}
</style>
